"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeFile = removeFile;

var _conf = _interopRequireDefault(require("../../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../../fetchUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function removeFile(farmId, fileId, type, language) {
  var uri = _conf.default.api.farmApiRemoveImage(language, farmId, fileId);

  if (type === 'documents') uri = _conf.default.api.farmApiRemoveDocument(language, farmId, fileId);
  return fetch(uri, {
    credentials: 'include',
    method: 'DELETE'
  }).then(_fetchUtils.default.checkStatus);
}


//////////////////
// WEBPACK FOOTER
// ./client/components/farm/lib/files.js
// module id = 157
// module chunks = 0